export const getOrCreateDeviceId = () => {
    let deviceId = localStorage.getItem('bgn_device_id');
    if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem('bgn_device_id', deviceId);
    }
    return deviceId;
};

export const getDeviceId = () => {
    return localStorage.getItem('bgn_device_id');
};

export const getPairingToken = () => {
    return localStorage.getItem('bgn_pairing_token');
};

export const setPairingToken = (token) => {
    localStorage.setItem('bgn_pairing_token', token);
};

export const clearPairingToken = () => {
    localStorage.removeItem('bgn_pairing_token');
};